module.exports = __webpack_public_path__ + "static/media/pg.f2479bfd.svg";